import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { useProducts } from '../../Context/ProductContext';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import './ProductSlider.css';

// --- CUSTOM ARROWS FOR CSS ---
const NextArrow = (props) => {
  const { className, onClick } = props;
  return (
    <button className={className} onClick={onClick} type="button">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
    </button>
  );
};

const PrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    <button className={className} onClick={onClick} type="button">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 18 9 12 15 6"></polyline>
      </svg>
    </button>
  );
};

const ProductSlider = ({ products: propProducts }) => {
  const { products: allProducts, isLoading } = useProducts();

  // Filter for bestsellers
  const bestSellerProducts = allProducts.filter(
    p => p.isBestSeller === true || p.isBestseller === true
  );

  const productsToShow = propProducts 
    ? propProducts 
    : (bestSellerProducts.length > 0 ? bestSellerProducts : allProducts.slice(0, 8));

  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  const settings = {
    dots: false,
    infinite: productsToShow.length > 4,
    speed: 100,
    slidesToShow: isMobile ? 1.8 : 4,
    slidesToScroll: 1,
    arrows: !isMobile, 
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 1100, settings: { slidesToShow: 3 } },
      { breakpoint: 900, settings: { slidesToShow: 2 } },
    ],
  };

  if (isLoading || productsToShow.length === 0) return null;

  return (
    <section className="product-slider-section" id="bestsellers">
      <div className="product-slider-inner">
        <Slider {...settings} className="product-slider">
          {productsToShow.map((p) => {
            
            // 1. Get real MRP from database
            const rawMRP = p?.variants?.[0]?.mrp || p?.mrp || '0'; 
            const mrp = String(rawMRP).includes('₹') ? rawMRP : `₹ ${rawMRP}`; 
            
            // 2. Get real selling price from database 
            const rawPrice = p?.variants?.[0]?.price || p?.price || rawMRP;
            const sellPrice = String(rawPrice).includes('₹') ? rawPrice : `₹ ${rawPrice}`;

            // 3. Dynamically calculate the discount percentage for the badge
            const numMRP = parseInt(String(mrp).replace(/[₹, ]/g, '')) || 0;
            const numPrice = parseInt(String(sellPrice).replace(/[₹, ]/g, '')) || 0;
            
            let discountPercent = 0;
            if (numMRP > numPrice && numMRP > 0) {
              discountPercent = Math.round(((numMRP - numPrice) / numMRP) * 100);
            }

            return (
              <div className="product-slide" key={p.id}>
                <div className="product-card">
                  {/* CHANGED: Link now uses the product slug if available, falling back to id */}
                  <Link to={`/product/${p.slug || p.id}`} className="all-product-thumb-link">
                    <div className="all-product-thumb">
                      
                      {/* Uses the global .discount-badge class from App.css */}
                      {discountPercent > 0 && (
                        <div className="discount-badge">{discountPercent}% OFF</div>
                      )}
                      
                      {/* --- IMAGE 1 (DEFAULT) --- */}
                      {p?.images?.[0] && (
                        <img 
                          src={p.images[0]} 
                          alt={p.title || 'Product Image'} 
                          className="product-image-1" 
                          width="300" height="400" 
                          fetchPriority="high"
                        />
                      )}

                      {/* --- IMAGE 2 (HOVER REVEAL) --- */}
                      {p?.images?.[1] && (
                        <img 
                          src={p.images[1]} 
                          alt={`${p.title || 'Product'} Hover`} 
                          className="product-image-2" 
                          width="300" height="400" 
                        />
                      )}
                    </div>
                  </Link>

                  <div className="product-meta">
                    <div className="product-title">{p.title}</div>
                    
                    {/* These classes perfectly match App.css */}
                    <div className="all-product-price-wrapper">
                      <span className="all-product-price">{sellPrice}</span>
                      
                      {/* Uses the global .all-product-mrp class from App.css */}
                      {discountPercent > 0 && (
                        <span className="all-product-mrp">{mrp}</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </section>
  );
};

export default ProductSlider;